import { useState } from 'react';

import { Api } from '../../api/api';
import type { Child } from '../../api/models';

import type { AddChildState } from './AddChildState';
import { canSubmit, readInteger } from './AddChildState';

/** Mirrors android/…/Screens/AddChild/AddChildViewModel.kt. */
export function useAddChild(onCreated: (child: Child) => void) {
  const [state, setState] = useState<AddChildState>({
    nickname: '',
    birthYear: '',
    schoolGrade: '',
    isSubmitting: false,
    error: null,
  });

  return {
    state,
    nickname: (nickname: string): void => setState((current) => ({ ...current, nickname, error: null })),
    birthYear: (birthYear: string): void => setState((current) => ({ ...current, birthYear, error: null })),
    schoolGrade: (schoolGrade: string): void =>
      setState((current) => ({ ...current, schoolGrade, error: null })),

    submit: async (): Promise<void> => {
      if (!canSubmit(state)) return;

      setState((current) => ({ ...current, isSubmitting: true, error: null }));

      const result = await Api.createChild({
        nickname: state.nickname.trim(),
        // `canSubmit` has already established both parse; the fallbacks are for the type checker.
        birthYear: readInteger(state.birthYear) ?? 0,
        schoolGrade: readInteger(state.schoolGrade) ?? 0,
      });

      if (result.ok) {
        setState((current) => ({ ...current, isSubmitting: false }));
        onCreated(result.value);

        return;
      }

      setState((current) => ({ ...current, isSubmitting: false, error: result.error.message }));
    },
  };
}
